import { Node, mergeAttributes } from "@tiptap/core";

export const TwitterBlockServerside = Node.create({
  name: "twitter",
  group: "block",
  content: "inline*",

  parseHTML() {
    return [
      {
        tag: 'a[data-type="twitter"',
      },
    ];
  },
  addAttributes() {
    return {
      url: { default: null },
      "data-id": { default: null },
      class: { default: "inline-twitter" },
    };
  },
  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(HTMLAttributes, {
        "data-type": "twitter",
        class: `react-renderer node-twitter ${HTMLAttributes.class}`,
      }),
      0,
    ];
  },
});
